import auth from '../../services/auth'

export default {

  data() {
    return {
      taxIdNumber: undefined,

      formState: 'NEW', 
      loading: false,
      chooseEmail: false,
      chooseCellphone: false,
      email: undefined,
      cellphone: undefined,
      channelSelected: undefined,
      origemTelas: undefined,
    }
  },

  watch: {
    channelSelectedForm(newValue) {
      if (this.channelSelected == 'email') {
        this.chooseEmail = true;
      } else 
      if (this.channelSelected == 'cellphone') {
        this.chooseCellphone = true;
      }
    },
  },

  computed: {
    type() {
      return this.$route.params.type;
    }
  },

  created(){
    this.taxIdNumber = this.$route.query.taxIdNumber;
    this.origemTelas = this.$route.params.type;
  },

  methods: {
    validate() {
      if(this.chooseEmail) {
        this.showCellphoneForm = false;
        this.showEmailForm = true;
      }
      if(this.chooseCellphone) {
        this.showCellphoneForm = true;
        this.showEmailForm = false;
      }
    },
    
    doRequest() {
      auth.saveHash(window.location.hash);
      this.formState = 'NEW';
      this.$validator.validateAll()
        .then(success => {
          let taxIdNumber = auth.getTaxIdNumber();
          auth.validUserResetPassword(taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase(), this.cellphone, this.email)
          .then(data => {
            if(data.status.code === 0) {
              this.$router.push({
                name: '2fa',
                params: {type: this.origemTelas}
              });
            }
          }).catch(err => {
            this.formState = 'ERROR';
            this.errorMessage = err.data.status.message;
        }); 
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/auth/choose-channel.js